export const API_URL = 'https://meetus-svelte-course.firebaseio.com';
